import { render, staticRenderFns } from "./EmailSignatureModalTrigger.vue?vue&type=template&id=83fbf5fe&"
import script from "./EmailSignatureModalTrigger.vue?vue&type=script&lang=js&"
export * from "./EmailSignatureModalTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports